import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Hotel } from 'app/shared/model/hotel';
import { UtilService } from 'app/shared/util.service';
import { FollowupPropertiesService } from 'app/inter-chain/followup/properties/followup-properties.service';
import { canLoadData, getRequestParams } from '../followup-summary-widgets.utils';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'mh-surveys-summary-semantic',
  templateUrl: './semantic-widget.component.html',
  standalone: false,
})
export class SemanticWidgetComponent implements OnChanges {
  @Input() chainFilter: Hotel[] = [];
  @Input() productId = 1;
  @Input() currentDates: any;
  @Input() surveysReady = false;

  @Output() loadingChange = new EventEmitter<boolean>();

  loading = false;
  positiveSemanticPercentage = 0;
  negativeSemanticPercentage = 0;

  constructor(
    private utilService: UtilService,
    private followupPropertiesService: FollowupPropertiesService,
    private router: Router,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes.chainFilter || changes.currentDates || changes.surveysReady) &&
      canLoadData(this.utilService, this.chainFilter, this.surveysReady)
    ) {
      this.loadData();
    }
  }

  get showSemanticEmpty(): boolean {
    return !this.positiveSemanticPercentage && !this.negativeSemanticPercentage;
  }

  loadData(): void {
    this.loading = true;
    this.loadingChange.emit(true);
    const { dates, surveyIds, customerIds } = getRequestParams(this.utilService, this.chainFilter, this.currentDates);

    this.followupPropertiesService
      .getSemanticIndex(dates, customerIds, this.productId, surveyIds)
      .pipe(
        finalize(() => {
          this.loading = false;
          this.loadingChange.emit(false);
        }),
      )
      .subscribe({
        next: (response: any) => this.handleSuccess(response),
        error: () => this.handleError(),
      });
  }

  private handleSuccess(response: any): void {
    if (response?.average?.sentiment_scores && Array.isArray(response.average.sentiment_scores)) {
      const positiveItem = response.average.sentiment_scores.find((item: any) => item.polarity === 'positive');
      const negativeItem = response.average.sentiment_scores.find((item: any) => item.polarity === 'negative');

      this.positiveSemanticPercentage = positiveItem ? positiveItem.percentage.actual : 0;
      this.negativeSemanticPercentage = negativeItem ? negativeItem.percentage.actual : 0;
    } else {
      this.positiveSemanticPercentage = 0;
      this.negativeSemanticPercentage = 0;
    }
  }

  private handleError(): void {
    this.positiveSemanticPercentage = 0;
    this.negativeSemanticPercentage = 0;
  }

  onActionClick(): void {
    this.utilService.ga('', 'interchain-followup-semanticwidget-viewmore');
    this.router.navigate(['/semantic/summary']);
  }
}
